import { render, staticRenderFns } from "./admin-page.vue?vue&type=template&id=13cf4c37&"
import script from "./admin-page.vue?vue&type=script&lang=js&"
export * from "./admin-page.vue?vue&type=script&lang=js&"
import style0 from "./admin-page.vue?vue&type=style&index=0&id=13cf4c37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports